module.exports = __webpack_public_path__ + "static/ACABADO DE TECHO-3097036fe0e29e99d2b8bebf8237620d.webp";